import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";

const URL = API_URL + "/st/license/user";
const VERSION = 2;

export async function createLicenseKey({
    featureIds,
    cancelURL,
    successURL
}: {
    featureIds: string[];
    successURL: string;
    cancelURL: string;
}) {
    let options: httpNetworking.POSTRequestConfig = {
        timeout: 10000
    };

    await httpNetworking.simplePOSTRequest(URL, { featureIds, cancelURL, successURL }, options, VERSION);
}
